import React, { Component } from "react";
import { Provider } from "react-redux";
import { style } from "react-toastify";
import colors from "../colors";

import App from "./App";

// toastify config
style({
  colorInfo: colors.primary,
  colorSuccess: colors.success,
  colorWarning: colors.warning,
  colorError: colors.danger
});

class Root extends Component {
  render() {
    const { store } = this.props;
    return (
      <Provider store={store}>
        <App />
      </Provider>
    );
  }
}

export default Root;



// WEBPACK FOOTER //
// ./src/app/Root.js